
import PageHeader from '../components/PageHeader'

const Human_Ethics_Committee = () => {
    return (

        <div>
            <PageHeader title="Human Ethics Committee" />
        </div>

    )
}

export default Human_Ethics_Committee